import { FormattedMessage } from "react-intl";

import { CounterInputField } from "@ps-design-system/components/CounterInput";
import { Text } from "@ps-design-system/components/Text";

import type { ListingUseType } from "../../../../../../components/src/services/listings.service";
import { USE_TYPE_SLUG } from "../../ActivateListingsPage.consts";

type CapacityFieldsProps = {
  useType: ListingUseType;
};

/** The "Capacity" section header and maximum guest count field. */
const CapacityFields = ({ useType }: CapacityFieldsProps) => {
  const slug = USE_TYPE_SLUG[useType];

  return (
    <>
      <Text
        typeface="headline-2-m"
        element="p"
        className="tw-border-b tw-border-gray-300 tw-py-8 tw-mb-8"
        testId={`activate-listing-form-${slug}-capacity-header`}
      >
        <FormattedMessage
          id="hosting.activate_listings.capacity_header"
          defaultMessage="Capacity"
        />
      </Text>

      {/** @ts-ignore - issues in design system */}
      <CounterInputField
        fullWidth
        name="numberOfGuests"
        min={0}
        label={
          <FormattedMessage
            id="hosting.activate_listings.capacity_label"
            defaultMessage="Maximum number of guests"
          />
        }
        required
        placeholder="250"
        testId={`activate-listing-form-${slug}-capacity-input`}
      />
    </>
  );
};

export { CapacityFields };
